import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthFacade } from '@core/services/auth-facade';
import { Notifier } from '@core/services/notifier';
import { Theme } from '@core/services/theme';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  notifier = inject(Notifier);
  readonly authFacade = inject(AuthFacade);
  readonly theme = inject(Theme);

  ngOnInit() {
    const lastError = sessionStorage.getItem('lastError');
    if (lastError) {
      this.notifier.error({ title: lastError });
      sessionStorage.removeItem('lastError');
    }
  }
}
